const validationPasswordCoginito = password => {
  try {
    let passValidation = { lowerCase: false, uperCase: false, number: false };
    if (password.length > 0) {
      password.split("").forEach(element => {
        if (/^[A-Z]*$/.test(element)) {
          passValidation.uperCase = true;
        } else if (/^[a-z]*$/.test(element)) {
          passValidation.lowerCase = true;
        } else if (/[0-9]/.test(element)) {
          passValidation.number = true;
        }
      });
    }

    return passValidation;
  } catch (error) {
    return { lowerCase: false, uperCase: false, number: false };
  }
};

export default validationPasswordCoginito;
